import React from "react";
import { ArrowRight, ShieldCheck, Compass } from "lucide-react";

const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/0deb5f24-12b6-46f7-ad4b-35e7525bf9a7/images/0af39c3326753bf859fac3099f62cb3164a77f62393bcf5ded6c941528ddbbf8.png";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 sm:pt-32 lg:pt-36 pb-20 sm:pb-28 overflow-hidden hero-grain"
    >
      {/* Soft background flourish */}
      <div
        aria-hidden="true"
        className="absolute top-0 right-0 w-[60%] h-[80%] pointer-events-none opacity-60"
        style={{
          background:
            "radial-gradient(ellipse at top right, rgba(212,162,76,0.18) 0%, rgba(212,162,76,0) 60%)",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-24 -left-24 w-[420px] h-[420px] pointer-events-none opacity-40"
        style={{
          background:
            "radial-gradient(circle, rgba(30,58,138,0.10) 0%, rgba(30,58,138,0) 70%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Copy */}
        <div className="lg:col-span-7 reveal visible">
          <div className="flex items-center gap-3 mb-7">
            <span className="lw-eyebrow">Private Wealth · Generational</span>
            <span
              aria-hidden="true"
              className="h-px w-10 bg-lw-gold/60"
            />
          </div>

          <h1
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl xl:text-[4.25rem] leading-[1.05] text-lw-navy"
            data-testid="hero-headline"
          >
            Build wealth for{" "}
            <span className="italic">every chapter</span>
            <br className="hidden sm:block" /> of life.
          </h1>

          <p
            className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-lw-muted"
            data-testid="hero-subhead"
          >
            From first steps to lasting legacy — Lifespan Wealth Partners helps
            families create, grow, and protect financial strength across
            generations. Independent guidance. Education-first. No pressure.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3 sm:gap-4">
            <a
              href="#tools"
              data-testid="hero-cta-explore-tools"
              className="btn-gold"
            >
              Explore Our Tools <ArrowRight size={18} />
            </a>
            <a
              href="#advisors"
              data-testid="hero-cta-talk-advisor"
              className="btn-ghost-navy"
            >
              <Compass size={18} /> Talk to an Advisor
            </a>
          </div>

          {/* Trust micro-line */}
          <div className="mt-10 flex items-center gap-5 text-xs sm:text-sm text-lw-muted">
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-lw-gold" />
              <span>Independent · Multiple carriers</span>
            </div>
            <div
              aria-hidden="true"
              className="h-4 w-px bg-lw-navy/15"
            />
            <span data-testid="hero-license-chip">Licensed in select states — see Compliance</span>
          </div>
        </div>

        {/* Image / visual */}
        <div className="lg:col-span-5 reveal visible">
          <div className="relative">
            <div
              aria-hidden="true"
              className="absolute -inset-4 sm:-inset-6 rounded-[2rem] gradient-navy-indigo opacity-[0.06] blur-2xl"
            />
            <div className="relative rounded-[1.75rem] overflow-hidden border border-lw-gold/30 shadow-[0_30px_80px_-30px_rgba(11,37,69,0.35)] bg-white">
              <img
                src={HERO_IMAGE}
                alt="A multi-generational family — symbolizing wealth across every stage of life"
                className="w-full h-auto object-cover"
                loading="eager"
                data-testid="hero-image"
              />
              {/* Bottom hairline */}
              <div className="gold-hairline" />
              {/* Floating credibility card */}
              <div className="absolute bottom-5 left-5 right-5 sm:left-6 sm:right-auto sm:max-w-[260px] bg-[#0B2545]/92 backdrop-blur-md rounded-xl p-4 border border-lw-gold/30">
                <div className="flex items-center gap-2 mb-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-lw-gold" />
                  <span className="font-sans-ui text-[0.65rem] tracking-[0.2em] uppercase text-lw-gold">
                    The Lifespan Arc
                  </span>
                </div>
                <p className="font-serif-display text-[#FAF8F3] text-lg leading-snug">
                  One plan. Five life stages. A lifetime of clarity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
